// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"cart-handler","172":"list-handler"}[chunkId] + "." + {"105":"88a28f40","172":"a9ad6e5b"}[chunkId] + ".js";
};